import { useState } from 'react';
import AutocompleteInput, { Option } from '@/components/inputs/AutocompleteInput';
import { useUsersOptions } from '../../../hooks';

import styles from './SearchBar.module.css';

interface SearchBarProps {
  searchValue: string;
  onSearch: (search: string) => void;
}

const SearchBar = ({ searchValue, onSearch }: SearchBarProps) => {
  const [userInput, setUserInput] = useState(searchValue || '');
  const [selectedUser, setSelectedUser] = useState<Option | null>(null);

  const { userOptions, isUsersLoading } = useUsersOptions({
    search: userInput,
  });

  const handleUserSelect = (option: Option | null) => {
    setSelectedUser(option);
    onSearch(option?.data?.id ? option.data.id : '');
  };

  return (
    <div className={styles.container}>
      <div style={{ display: 'flex', gap: '20px', justifyContent: 'flex-end' }}>
        <AutocompleteInput
          name='user-assignments-search'
          placeholder='Buscar usuario'
          value={selectedUser}
          onChange={handleUserSelect}
          onInputChange={setUserInput}
          options={userOptions}
          required={false}
          disabled={isUsersLoading}
        />
      </div>
    </div>
  );
};

export default SearchBar;
